<template>
  <div class="vms-org-shell mb-6">
    <v-toolbar dense class="vms-org-toolbar py-2" elevation="0" flat>

      <v-btn icon class="ml-1" @click="backToFacilityList">
        <v-icon class="info--text font-weight-bold">mdi-keyboard-backspace</v-icon>
      </v-btn>

      <v-toolbar-title class="info--text font-weight-bold text--darken-1">
        <v-breadcrumbs :items="items" large class="pa-0">
          <template v-slot:divider>
            <v-icon color="info">mdi-chevron-right</v-icon>
          </template>
          <template v-slot:item="{ item }">
            <v-breadcrumbs-item @click="changeFacility(item)" style="cursor: pointer;">
              {{ item.text }}
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-hover v-slot="{ hover }">
            <v-btn :class="{ 'info--text': hover }" icon v-bind="attrs" v-on="on" @click="loadFacilityOrganizations">
              <v-icon color="info">mdi-home-city</v-icon>
            </v-btn>
          </v-hover>
        </template>
        <span class="text-caption">Organizations</span>
      </v-tooltip>

      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-hover v-slot="{ hover }">
            <v-btn :class="{ 'info--text': hover }" icon v-bind="attrs" v-on="on" @click="loadFacilityBlacklist">
              <v-icon color="info">mdi-account-cancel</v-icon>
            </v-btn>
          </v-hover>
        </template>
        <span class="text-caption">Blacklist</span>
      </v-tooltip>

      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-hover v-slot="{ hover }">
            <v-btn :class="{ 'info--text': hover }" icon class="mr-1" v-bind="attrs" v-on="on" @click="loadFacilities">
              <v-icon color="success">mdi-bank</v-icon>
            </v-btn>
          </v-hover>
        </template>
        <span class="text-caption">Facilities</span>
      </v-tooltip>

    </v-toolbar>

    <div class="vms-org-content">
      <FacilityOrganizations v-if="showFacilityOrganizations" v-bind:facility="facility"></FacilityOrganizations>
      <Blacklist v-if="showFacilityBlacklist" v-bind:facility="facility"></Blacklist>
      <Location v-if="showFacilityLocation" v-bind:facility="facility"></Location>
      <FacilityDashboard v-if="showFacilities" :parentFacility="facility" @select_facility="selectFacility" :selectedFacility="selectedFacility"></FacilityDashboard>
    </div>
  </div>
</template>

<script>
import FacilityOrganizations from './Organizations.vue';
import Location from './Location.vue';
import Blacklist from './Blacklist.vue';
import FacilityDashboard from './FacilityDashboard.vue';

export default {
  components: { 
    FacilityOrganizations, 
    Blacklist, 
    Location,
    FacilityDashboard 
  },
  name: "Dashboard",
  props: [
    'facility',
    'tabId'
  ],
  data() {
    return {
      showFacilityOrganizations: true,
      showFacilityBlacklist: false,
      showFacilityLocation: false,
      showFacilities: false,
      items: [
        {
          text: 'Dashboard',
          disabled: false,
        },
      ],
      selectedFacility: {},
    }
  },

  mounted() {
    if (this.tabId == 4) {
      this.loadFacilities();
    }

    this.$nextTick(() => {
      this.items = [];

      this.items.push({
        id: this.facility?.id,
        text: this.facility?.attributes?.facility,
        disabled: false,
      });
    });
  },

  methods: {
    backToFacilityList() {
      this.$emit('goToFacilityList', 'Come Back');
    },

    loadFacilityOrganizations() {
      this.showFacilityOrganizations = true;
      this.showFacilityBlacklist = false;
      this.showFacilityLocation = false;
      this.showFacilities = false;
    },

    loadFacilityLocation() {
      this.showFacilityLocation = true;
      this.showFacilityBlacklist = false;
      this.showFacilityOrganizations = false;
      this.showFacilities = false;
    },

    loadFacilityBlacklist() {
      this.showFacilityLocation = false;
      this.showFacilityBlacklist = true;
      this.showFacilityOrganizations = false;
      this.showFacilities = false;
    },

    loadFacilities() {
      this.showFacilityLocation = false;
      this.showFacilityBlacklist = false;
      this.showFacilityOrganizations = false;
      this.showFacilities = true;
    },

    selectFacility(payload) {
      if (payload.selectedTabId == 1) {
        this.loadFacilityOrganizations();
      }

      this.$emit('select_facility', payload);
      this.changeFacilities(payload.selectedFacility);
    },

    changeFacility(e) {
      let index = -1;
      index = this.items.findIndex((item) => item.id == e.id);
      if (index > -1) {
        this.$nextTick(() => {
          this.selectedFacility = Object.assign(this.selectedFacility, {});
          this.selectedFacility = this.items[index];
          this.items.splice(++index, (this.items?.length - 1));
          this.$emit('select_facility', { selectedTabId: 4, selectedFacility: this.selectedFacility });
        });
      }
    },

    changeFacilities(facility) {
      this.items.push({
        id: facility?.id,
        text: facility?.attributes?.facility,
        disabled: false,
      });
    },
  }
}
</script>